import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Divider from 'material-ui/Divider';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import FlatButton from 'material-ui/FlatButton';
import Toggle from 'material-ui/Toggle';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { vAlignCenter } from '../style';
import TextFit from 'react-fittext';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'

import Home from 'material-ui/svg-icons/action/home';
import Payment from 'material-ui/svg-icons/action/payment';
import Comment from 'material-ui/svg-icons/communication/comment';
import Person from 'material-ui/svg-icons/social/person';
import Forum from 'material-ui/svg-icons/communication/forum';

import CenteredCol from './shared/CenteredCol';
import ContactInfo from '../components/ContactInfo';
import Login from './auth/Login';
import Logout from './auth/Logout';
import Register from './auth/Register';

const appBarStyle = {
    position: "inherit", 
    top: 0, 
    zIndex: 1200, 
    width: "100%", 
    backgroundImage: "url(img/lawn.jpg)",
    backgroundPosition: "center",
    boxShadow: "inset 0 0 0 1000px rgba(0,0,0,.2)"
};


const title = <TextFit><h1 style={{fontFamily: "sarif", fontWeight: "600", color: "#d29915", marginLeft: "-2.1rem"}}>Viking Services</h1></TextFit>;

const NavTitle = props => (
    <Row>
        <Col xs={12}>
            <Row style={{marginBottom: 0}}>
                <Col xs={12} sm={5}>
                    <Link to='/'>
                        {title}
                    </Link>
                    <ContactInfo />
                </Col>
            </Row>
        </Col>
    </Row>
);

class Nav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {open: false};
    }

    handleToggle = () => this.setState({open: !this.state.open});

    handleClose = () => this.setState({open: false});

    render() {
        const { history, logged } = this.props;
        return <AppBar 
            title={"Viking Services"}
            titleStyle={{cursor: 'pointer'}}
            onTitleTouchTap={() => history.push('/')}
            zDepth={2}
            onLeftIconButtonTouchTap={this.handleToggle}
            children={
                <Drawer
                    docked={false}
                    open={this.state.open}
                    onRequestChange={(open) => this.setState({open})}
                >
                    <Logout/>
                    {/* <Login trigger={
                        <MenuItem leftIcon={<Person color="#83b366"/>} onTouchTap={this.handleClose}>
                            <span style={{color: "#83b366", fontWeight: 900, fontSize: "22px"}}>
                                Login
                            </span>
                        </MenuItem>
                    }/>
                    {
                        !logged && 
                        <Link to="/Register"> 
                            <MenuItem leftIcon={<Person />} onTouchTap={this.handleClose}>
                                <span style={{ fontWeight: 900, fontSize: "22px"}}>
                                    Register
                                </span>
                            </MenuItem>
                        </Link>
                    } */}
                    <Divider />
                    <Link to={ logged ? '/Dashboard' : '/'}>
                        <MenuItem leftIcon={<Home/>} onTouchTap={this.handleClose}>
                                <span style={{color: "darkgrey", fontWeight: 900, fontSize: "22px"}}>
                                    Home
                                </span>
                        </MenuItem>
                    </Link>
                    <Link to='Pay'>
                        <MenuItem leftIcon={<Payment/>} onTouchTap={this.handleClose}>
                            <span style={{color: "darkgrey", fontWeight: 900, fontSize: "22px"}}>
                                Pay
                            </span>
                        </MenuItem>
                    </Link>
                    {/* <Link to='Review'>
                        <MenuItem leftIcon={<Forum />} onTouchTap={this.handleClose}>
                            <span style={{color: "darkgrey", fontWeight: 900, fontSize: "22px"}}>
                                Services
                            </span>
                        </MenuItem>
                    </Link> */}
                </Drawer>
            }
        />;
    }
};

export default connect(state => ({ logged: state.auth.logged }), null)(Nav);


// WEBPACK FOOTER //
// ./src/components/Nav.js